/* PV2 — ported from pv2home.com/js/main.js
   Differences from the original, all deliberate:
   - classes are pv2- prefixed
   - the hero word stagger is done in Liquid (inline animation-delay), not here
   - the footer year is {{ 'now' | date: '%Y' }}, not JS
   - Shopify theme-editor events are handled: sections load and re-order
     dynamically there, and without this they render blank (opacity 0). */
(function () {
  var inDesign = window.Shopify && window.Shopify.designMode;

  function initNav(root) {
    var nav = (root || document).querySelector('.pv2-nav');
    if (!nav || nav.dataset.pv2Bound) return;
    nav.dataset.pv2Bound = '1';
    var after = parseInt(nav.getAttribute('data-scrolled-after') || '40', 10);
    var onScroll = function () {
      if (window.scrollY > after) nav.classList.add('pv2-scrolled');
      else nav.classList.remove('pv2-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var tog = nav.querySelector('.pv2-navtoggle');
    if (!tog) return;
    var setMenu = function (open) {
      nav.classList.toggle('pv2-menu-open', open);
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    tog.addEventListener('click', function (e) {
      e.stopPropagation();
      setMenu(!nav.classList.contains('pv2-menu-open'));
    });
    nav.querySelectorAll('.pv2-navlinks a').forEach(function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('pv2-menu-open') && !nav.contains(e.target)) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setMenu(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 960) setMenu(false);
    });
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('pv2-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.14 }) : null;

  /* Observe elements that ALREADY carry .pv2-reveal -- exactly what the original
     main.js did. Do NOT auto-add .pv2-reveal to anything.

     An earlier version added it to every top-level child of .pv2-prose. Because the
     page bodies are full <section> markup, that faded whole sections in as a block
     while their children faded again inside them -- 9 nested reveals on the travel
     page, which read as a scroll glitch. Every PV2 page body already marks its own
     reveal targets explicitly, so there is nothing to infer. */
  function initReveals(root, force) {
    (root || document).querySelectorAll('.pv2-reveal').forEach(function (el) {
      if (el.dataset.pv2Seen) return;
      el.dataset.pv2Seen = '1';
      if (force || !io) { el.classList.add('pv2-in'); return; }
      io.observe(el);
    });
  }

  function animateN(el) {
    var target = el.getAttribute('data-pv2-n');
    var num = parseInt(target.replace(/[^0-9]/g, ''), 10);
    if (isNaN(num)) { el.textContent = target; return; }
    var prefix = target.match(/^[^0-9]*/)[0], suffix = target.match(/[^0-9]*$/)[0];
    var t0 = null, dur = 1100;
    var tick = function (t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + Math.round(num * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  var io2 = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { animateN(e.target); io2.unobserve(e.target); }
    });
  }, { threshold: 0.6 }) : null;

  function initCounters(root, force) {
    (root || document).querySelectorAll('[data-pv2-n]').forEach(function (el) {
      if (el.dataset.pv2Counted) return;
      el.dataset.pv2Counted = '1';
      if (force || !io2) { el.textContent = el.getAttribute('data-pv2-n'); return; }
      io2.observe(el);
    });
  }

  function initAccordions(root) {
    (root || document).querySelectorAll('.pv2-acc-item').forEach(function (item) {
      if (item.dataset.pv2Bound) return;
      item.dataset.pv2Bound = '1';
      var q = item.querySelector('.pv2-acc-q');
      var a = item.querySelector('.pv2-acc-a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('pv2-open');
        if (open) { item.classList.remove('pv2-open'); a.style.maxHeight = null; q.setAttribute('aria-expanded', 'false'); }
        else { item.classList.add('pv2-open'); a.style.maxHeight = a.scrollHeight + 'px'; q.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---- buy panel ----
     Pack pills and the stepper both write ONE number: quantity. There are no
     multipack variants, because Amazon MCF maps one Shopify SKU to one Amazon
     SKU -- a 3-box order is quantity 3 of PV2_LDS_32PK-FBA.

     Price shown = the data-pack-prices table when that quantity is in it,
     otherwise quantity x unit price. The table is rendered from the section's
     `pack_prices` setting, which must only be filled in when matching Shopify
     automatic quantity discounts exist -- otherwise this would quote a price
     the checkout will not honour. Off the end of the table (stepper past the
     last pack) it falls back to straight multiplication, which is always what
     the cart charges when no discount applies. */
  function money(cents, prefix) {
    return (prefix || '$') + (cents / 100).toFixed(2);
  }

  function packPrices(panel) {
    var raw = panel.getAttribute('data-pack-prices');
    if (!raw) return null;
    try {
      var t = JSON.parse(raw);
      return (t && typeof t === 'object') ? t : null;
    } catch (e) { return null; }
  }

  function setQty(panel, n) {
    n = Math.max(1, n | 0);
    var unit = parseInt(panel.getAttribute('data-unit-cents') || '0', 10);
    var loads = parseInt(panel.getAttribute('data-loads-per-box') || '0', 10);
    var prefix = panel.getAttribute('data-money-prefix') || '$';

    var field = panel.querySelector('input[name="quantity"]');
    if (field) field.value = n;
    var out = panel.querySelector('[data-qty-value]');
    if (out) out.textContent = n;

    if (unit) {
      var table = packPrices(panel);
      var listed = table && table[n];
      var total = (typeof listed === 'number' && listed > 0) ? listed : unit * n;
      var priceEl = panel.querySelector('.pv2-price');
      if (priceEl) priceEl.textContent = money(total, prefix);
      var sb = document.querySelector('.pv2-stickybuy .pv2-sb-p');
      if (sb) sb.textContent = money(total, prefix);
      var perEl = panel.querySelector('.pv2-perload');
      if (perEl && loads) {
        var tl = loads * n;
        perEl.textContent = money(Math.round(total / tl), prefix) + ' per load at ' + tl + ' loads';
      }
    }

    panel.querySelectorAll('.pv2-vp').forEach(function (p) {
      p.classList.toggle('pv2-sel', parseInt(p.getAttribute('data-qty'), 10) === n);
    });
  }

  function initBuy(root) {
    (root || document).querySelectorAll('.pv2-buypanel').forEach(function (panel) {
      if (panel.dataset.pv2Bound) return;
      panel.dataset.pv2Bound = '1';

      panel.querySelectorAll('.pv2-vp').forEach(function (p) {
        p.addEventListener('click', function () {
          setQty(panel, parseInt(p.getAttribute('data-qty'), 10) || 1);
        });
      });

      panel.querySelectorAll('.pv2-qty button').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var field = panel.querySelector('input[name="quantity"]');
          var cur = parseInt((field && field.value) || '1', 10) || 1;
          setQty(panel, cur + (b.getAttribute('data-d') === '+' ? 1 : -1));
        });
      });
    });

    (root || document).querySelectorAll('.pv2-thumbs').forEach(function (t) {
      if (t.dataset.pv2Bound) return;
      t.dataset.pv2Bound = '1';
      t.querySelectorAll('[data-full]').forEach(function (d) {
        d.addEventListener('click', function () {
          t.querySelectorAll('[data-full]').forEach(function (x) { x.classList.remove('pv2-sel'); });
          d.classList.add('pv2-sel');
          var media = t.closest('.pv2-pdp-media');
          var main = media && media.querySelector('.pv2-main img');
          if (main) { main.removeAttribute('srcset'); main.src = d.getAttribute('data-full'); }
        });
      });
    });
  }

  function initAll(root, force) {
    initNav(root);
    initReveals(root, force);
    initCounters(root, force);
    initAccordions(root);
    initBuy(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document, false); });
  } else {
    initAll(document, false);
  }

  /* In the theme editor sections mount after load and are never scrolled
     into view, so reveal them immediately or they look blank. */
  if (inDesign) {
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target, true); });
    document.addEventListener('shopify:section:reorder', function () { initAll(document, true); });
    document.addEventListener('shopify:section:select', function (e) { initAll(e.target, true); });
  }
})();
